import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "./helper";

export type IdLookupType = "userId" | "clientUniqueRefId";

export interface IdLookupResponse {
  user: {
    _id: string;
    clientUniqueRefId: string;
    name?: string;
  };
  relations: Array<{
    worker: {
      _id: string;
      clientRefId: string;
      userId: string;
      employerId: string;
    };
    employer: {
      _id: string;
      clientRefId: string;
      name: string;
    } | null;
  }>;
}

type GetIdLookupRequestDto = {
  type: IdLookupType;
  id: string;
};

export const idLookupActionSlice = createApi({
  baseQuery,
  reducerPath: "idLookupApi",
  endpoints: (build) => ({
    getIdLookup: build.query<IdLookupResponse, GetIdLookupRequestDto>({
      query: ({ type, id }) => {
        return {
          url: `/workers/id-lookup`,
          params: { type, id },
          method: "GET",
        };
      },
    }),
  }),
});

export const { useLazyGetIdLookupQuery } = idLookupActionSlice;